window.addEventListener("DOMContentLoaded", () => {
  const countdowns = document.querySelectorAll('hero-banner-countdown-timer');
  countdowns.forEach((countdown) => {
    countdown.setValues = (values) => {
      if (values.length !== countdown.digitElements.length) {
        console.error("Invalid values provided.");
        return;
      }

      values.forEach((value, index) => {
        countdown.digitElements[index].textContent = value;
      });
    };
    countdown.getTimeParts = (delta) => {
      const days = Math.floor(delta / 86400);
      delta -= days * 86400;

      const hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;

      const minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;

      const seconds = Math.floor(delta % 60); // in theory the modulus is not required

      return [days, hours, minutes, seconds];
    };

    countdown.renderTimer = (delta) => {
      const timeParts = countdown.getTimeParts(delta);
      countdown.setValues(timeParts);
    };

    countdown.startTimer = () => {
      const intervalId = setInterval(() => {
        const delta = (countdown.endTime - Date.now()) / 1000;
        if (delta >= 0) {
          countdown.renderTimer(delta);
        } else {
          countdown.querySelector(".countdown-timer")?.classList?.add("!hidden");
          countdown.querySelector(".countdown-title")?.classList?.add("!hidden");
          clearInterval(intervalId);
        }
      }, 1000);
    };

    countdown.digitElements = Array.from(countdown.querySelectorAll(".digit"));
    countdown.startTime = Date.now();
    countdown.endTime = null;

    countdown.endTime = new Date(countdown.getAttribute("end-time").replace(" ", "T"));
    countdown.startTimer();
    setTimeout(() => {
      countdown.style.display = 'block';
    }, 1000);
  });
});
